import React, { useMemo } from 'react';
import { OrgHostProvider, useOrgHost } from '@/contexts/OrgHostContext';
import { OrgPublicProfileProvider } from '@/contexts/OrgPublicProfileContext';
import { getTenantSubdomainContext } from '@/lib/tenantHost';
import { GTMPageViewTracker } from '@/components/GTMPageViewTracker';
import { OrgPublicRoutes } from '@/routes/OrgPublicRoutes';

const spinner = (
  <div className="flex min-h-[200px] items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900 dark:border-white" />
  </div>
);

function OrgSubdomainShell({ children }: { children: React.ReactNode }) {
  const { loading, error } = useOrgHost();

  if (loading) return spinner;
  if (error) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center">
        <h1 className="text-xl font-semibold">Site not found</h1>
        <p className="mt-2 text-muted-foreground">{error}</p>
      </div>
    );
  }
  return <>{children}</>;
}

export default function SubdomainTenantApp() {
  const hostContext = useMemo(() => getTenantSubdomainContext(), []);

  return (
    <>
      <GTMPageViewTracker />
      <div className="min-h-svh bg-white dark:bg-gray-900">
        <OrgHostProvider hostContext={hostContext}>
          <OrgSubdomainShell>
            <OrgPublicProfileProvider>
              <OrgPublicRoutes subdomain />
            </OrgPublicProfileProvider>
          </OrgSubdomainShell>
        </OrgHostProvider>
      </div>
    </>
  );
}
